import { Tabs } from '@treams/treams-ui';
import { useTranslation } from 'react-i18next';

export default function ViewerConversationTabs() {
	const { t } = useTranslation();

	return (
		<Tabs.Container>
			<Tabs.Item title={t('conversations.tab.incoming.title')} selected path="/conversations" />
			<Tabs.Item title={t('conversations.tab.outgoing.title')} path="/conversations/outgoing" />
		</Tabs.Container>
	);
}
